import { focusToEditor } from 'owa-editor';
import setIsRibbonShown from 'owa-calendar-compose-form-store/lib/actions/setIsRibbonShown';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { lazyUpdateRibbonWidth } from 'owa-editor-ribbonplugin';

export default function toggleRibbon() {
    let fullComposeViewState = getFullComposeViewState();
    if (fullComposeViewState) {
        setIsRibbonShown(fullComposeViewState, !fullComposeViewState.isRibbonShown);

        if (fullComposeViewState.isRibbonShown) {
            resizeRibbon();

            window.setTimeout(() => focusToEditor(fullComposeViewState.bodyViewState), 0);
        }
    }
}

export function resizeRibbon() {
    let fullComposeViewState = getFullComposeViewState();
    if (fullComposeViewState) {
        lazyUpdateRibbonWidth.importAndExecute(
            fullComposeViewState.ribbon,
            fullComposeViewState.docking.dockingWidth
        );
    }
}
